/**
 *
 * MediaPreview
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
//import { Button } from 'antd';

// Communication components
import {
  FBSectionHeader,
  FBPreviewFile,
} from 'components/Communications';

// icons
import CustomIcons from 'components/CustomIcons';


function MediaPreview({
  media,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-documents-group-preview', 'tcf-fb-group-preview', className);
  
  return !!media && (
    <div {...rest} className={childClassNames}>
    {/*   <FBSectionHeader type="documents" /> */}
      <div className='tcf-fb-group-preview__content'>
        {media?.map((file, fileIndx) => {
          return !!file && (
            <FBPreviewFile
              key={`MediaPreviewFile-${fileIndx}`}
              showTitle={false}
              file={file?.url}
              fileType={file?.type}
              showIcon={true}
              showIconPreview={true}
              iconPreview={<CustomIcons className="icon-preview" type="arrow-right" />}
            />
          );
        })}
      </div>
      
    </div>
  );
}

MediaPreview.defaultProps = {
  type: 'media',
};
MediaPreview.propTypes = {
  media: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};

export default memo(MediaPreview);
